"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _marshaler = _interopRequireDefault(require("../util/marshaler"));

var _combineStreams = _interopRequireDefault(require("../util/combine-streams"));

var _constants = require("../util/constants");

var _apiKeys = _interopRequireDefault(require("./api-keys"));

var _collaborators = _interopRequireDefault(require("./collaborators"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var Gateways = /*#__PURE__*/function () {
  function Gateways(api, _ref) {
    var defaultUserId = _ref.defaultUserId,
        stackConfig = _ref.stackConfig;
    (0, _classCallCheck2["default"])(this, Gateways);
    this._api = api;
    this._defaultUserId = defaultUserId;
    this._stackConfig = stackConfig;
    this.ApiKeys = new _apiKeys["default"](api.GatewayAccess, {
      parentRoutes: {
        get: 'gateway_ids.gateway_id',
        list: 'gateway_ids.gateway_id',
        create: 'gateway_ids.gateway_id',
        update: 'gateway_ids.gateway_id'
      }
    });
    this.Collaborators = new _collaborators["default"](api.GatewayAccess, {
      parentRoutes: {
        get: 'gateway_ids.gateway_id',
        list: 'gateway_ids.gateway_id',
        set: 'gateway_ids.gateway_id'
      }
    });
  }

  (0, _createClass2["default"])(Gateways, [{
    key: "_emitDefaults",
    value: function _emitDefaults(paths, gateway) {
      // Handle zero coordinates that are swallowed by the grpc-gateway for
      // gateway antennas.
      if (paths.includes('antennas') && Boolean(gateway.antennas)) {
        var antennas = gateway.antennas;

        var _iterator = _createForOfIteratorHelper(antennas),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var antenna = _step.value;

            if (!('altitude' in antenna.location)) {
              antenna.location.altitude = 0;
            }

            if (!('longitude' in antenna.location)) {
              antenna.location.longitude = 0;
            }

            if (!('latitude' in antenna.location)) {
              antenna.location.latitude = 0;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } // Handle missing boolean values.


      if (paths.includes('location_public') && !Boolean(gateway.location_public)) {
        gateway.location_public = false;
      }

      if (paths.includes('status_public') && !Boolean(gateway.status_public)) {
        gateway.status_public = false;
      }

      if (paths.includes('auto_update') && !Boolean(gateway.auto_update)) {
        gateway.auto_update = false;
      }

      if (paths.includes('schedule_downlink_late') && !Boolean(gateway.schedule_downlink_late)) {
        gateway.schedule_downlink_late = false;
      }

      if (paths.includes('require_authenticated_connection') && !Boolean(gateway.require_authenticated_connection)) {
        gateway.require_authenticated_connection = false;
      }

      if (paths.includes('update_location_from_status') && !Boolean(gateway.update_location_from_status)) {
        gateway.update_location_from_status = false;
      }

      return gateway;
    } // Retrieval.

  }, {
    key: "getAll",
    value: function () {
      var _getAll = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(params, selector) {
        var response;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._api.GatewayRegistry.List(undefined, _objectSpread(_objectSpread({}, params), _marshaler["default"].selectorToFieldMask(selector)));

              case 2:
                response = _context.sent;
                return _context.abrupt("return", _marshaler["default"].unwrapGateways(response));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getAll(_x, _x2) {
        return _getAll.apply(this, arguments);
      }

      return getAll;
    }()
  }, {
    key: "getById",
    value: function () {
      var _getById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(id, selector) {
        var fieldMask, response;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                fieldMask = _marshaler["default"].selectorToFieldMask(selector);
                _context2.next = 3;
                return this._api.GatewayRegistry.Get({
                  routeParams: {
                    'gateway_ids.gateway_id': id
                  }
                }, fieldMask);

              case 3:
                response = _context2.sent;
                return _context2.abrupt("return", this._emitDefaults(fieldMask.field_mask.paths, _marshaler["default"].unwrapGateway(response)));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getById(_x3, _x4) {
        return _getById.apply(this, arguments);
      }

      return getById;
    }()
  }, {
    key: "search",
    value: function () {
      var _search = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(params, selector) {
        var response;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._api.EntityRegistrySearch.SearchGateways(undefined, _objectSpread(_objectSpread({}, params), _marshaler["default"].selectorToFieldMask(selector)));

              case 2:
                response = _context3.sent;
                return _context3.abrupt("return", _marshaler["default"].unwrapGateways(response));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function search(_x5, _x6) {
        return _search.apply(this, arguments);
      }

      return search;
    }() // Update.

  }, {
    key: "updateById",
    value: function () {
      var _updateById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(id, patch) {
        var mask,
            response,
            _args4 = arguments;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                mask = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : _marshaler["default"].fieldMaskFromPatch(patch, this._api.GatewayRegistry.UpdateAllowedFieldMaskPaths);
                _context4.next = 3;
                return this._api.GatewayRegistry.Update({
                  routeParams: {
                    'gateway.ids.gateway_id': id
                  }
                }, {
                  gateway: patch,
                  field_mask: _marshaler["default"].fieldMask(mask)
                });

              case 3:
                response = _context4.sent;
                return _context4.abrupt("return", this._emitDefaults(mask, _marshaler["default"].unwrapGateway(response)));

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function updateById(_x7, _x8) {
        return _updateById.apply(this, arguments);
      }

      return updateById;
    }() // Creation.

  }, {
    key: "create",
    value: function () {
      var _create = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
        var ownerId,
            gateway,
            isUserOwner,
            routeParams,
            response,
            _args5 = arguments;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                ownerId = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : this._defaultUserId;
                gateway = _args5.length > 1 ? _args5[1] : undefined;
                isUserOwner = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : true;
                routeParams = isUserOwner ? {
                  'collaborator.user_ids.user_id': ownerId
                } : {
                  'collaborator.organization_ids.organization_id': ownerId
                };
                _context5.next = 6;
                return this._api.GatewayRegistry.Create({
                  routeParams: routeParams
                }, {
                  gateway: gateway
                });

              case 6:
                response = _context5.sent;
                return _context5.abrupt("return", _marshaler["default"].unwrapGateway(response));

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function create() {
        return _create.apply(this, arguments);
      }

      return create;
    }() // Deletion.

  }, {
    key: "deleteById",
    value: function () {
      var _deleteById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(id) {
        var response;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this._api.GatewayRegistry.Delete({
                  routeParams: {
                    gateway_id: id
                  }
                });

              case 2:
                response = _context6.sent;
                return _context6.abrupt("return", _marshaler["default"].payloadSingleResponse(response));

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function deleteById(_x9) {
        return _deleteById.apply(this, arguments);
      }

      return deleteById;
    }()
  }, {
    key: "purgeById",
    value: function () {
      var _purgeById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(id) {
        var response;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this._api.GatewayRegistry.Purge({
                  routeParams: {
                    gateway_id: id
                  }
                });

              case 2:
                response = _context7.sent;
                return _context7.abrupt("return", _marshaler["default"].payloadSingleResponse(response));

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function purgeById(_x10) {
        return _purgeById.apply(this, arguments);
      }

      return purgeById;
    }() // Miscellaneous.

  }, {
    key: "getStatisticsById",
    value: function () {
      var _getStatisticsById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(id) {
        var response;
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this._api.Gs.GetGatewayConnectionStats({
                  routeParams: {
                    gateway_id: id
                  }
                });

              case 2:
                response = _context8.sent;
                return _context8.abrupt("return", _marshaler["default"].payloadSingleResponse(response));

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getStatisticsById(_x11) {
        return _getStatisticsById.apply(this, arguments);
      }

      return getStatisticsById;
    }()
  }, {
    key: "getRightsById",
    value: function () {
      var _getRightsById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(gatewayId) {
        var result;
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this._api.GatewayAccess.ListRights({
                  routeParams: {
                    gateway_id: gatewayId
                  }
                });

              case 2:
                result = _context9.sent;
                return _context9.abrupt("return", _marshaler["default"].unwrapRights(result));

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function getRightsById(_x12) {
        return _getRightsById.apply(this, arguments);
      }

      return getRightsById;
    }() // Events Stream

  }, {
    key: "openStream",
    value: function () {
      var _openStream = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(identifiers, tail, after) {
        var _this = this;

        var payload, distinctComponents, streams;
        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                payload = {
                  identifiers: identifiers.map(function (id) {
                    return {
                      gateway_ids: {
                        gateway_id: id
                      }
                    };
                  }),
                  tail: tail,
                  after: after
                }; // Event streams can come from multiple stack components. It is necessary to
                // check for stack components on different hosts and open distinct stream
                // connections for any distinct host if need be.

                distinctComponents = this._stackConfig.getComponentsWithDistinctBaseUrls([_constants.STACK_COMPONENTS_MAP.is, _constants.STACK_COMPONENTS_MAP.gs]);
                streams = distinctComponents.map(function (component) {
                  return _this._api.Events.Stream({
                    component: component
                  }, payload);
                }); // Combine all stream sources to one subscription generator.

                return _context10.abrupt("return", (0, _combineStreams["default"])(streams));

              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function openStream(_x13, _x14, _x15) {
        return _openStream.apply(this, arguments);
      }

      return openStream;
    }() // Gateway Configuration Server.

  }, {
    key: "getGlobalConf",
    value: function () {
      var _getGlobalConf = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11(gatewayId) {
        var endpoint, response;
        return _regenerator["default"].wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                // Endpoint hardcoded because it is not part of the gRPC API.
                // Refactor implementation once the following issue is resolved:
                // https://github.com/TheThingsNetwork/lorawan-stack/issues/3280
                endpoint = "/gcs/gateways/".concat(gatewayId, "/semtechudp/global_conf.json");
                _context11.next = 3;
                return this._api._connector.handleRequest('get', endpoint, 'gcs', false);

              case 3:
                response = _context11.sent;
                return _context11.abrupt("return", _marshaler["default"].payloadSingleResponse(response.data));

              case 5:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function getGlobalConf(_x16) {
        return _getGlobalConf.apply(this, arguments);
      }

      return getGlobalConf;
    }()
  }]);
  return Gateways;
}();

var _default = Gateways;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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